import React from 'react';
import './HelpAndSupport.css';

const HelpAndSupport = () => {
  return (
    <div className="HelpAndSupport">
      <h1>HelpAndSupport</h1>
    </div>
  );
};

export default HelpAndSupport;
